import DpModalBase from './DpModalBase';
import DpModalWithGradientButton from './DpModalWithGradientButton';

type DpModalBaseType = typeof DpModalBase & { WithGradientButton: typeof DpModalWithGradientButton };

const DpModal = DpModalBase as DpModalBaseType;

DpModal.WithGradientButton = DpModalWithGradientButton;

export default DpModal;

export { DpModalWithGradientButton };
